import { isEmpty } from "@swiggy-private/js-utils";
import { CutleryOptInOutWidget } from "@swiggy-private/cart-ui";
import React from "react";

interface CutleryOptOutProps {
    showCutleryTile: boolean;
    isCutleryOpted: boolean;
    toggleCutlery: () => void;
    cutleryRef: React.RefObject<HTMLDivElement>;
    title?: string;
}

const CutleryOptOut: React.FC<CutleryOptOutProps> = (props) => {
    const { showCutleryTile, isCutleryOpted, toggleCutlery, cutleryRef, title } = props;
    if (isEmpty(showCutleryTile)) return null;
    return (
        <CutleryOptInOutWidget
            checked={isCutleryOpted}
            onCutleryOptChange={toggleCutlery}
            cutleryRef={cutleryRef}
            title={title}
        />
    );
};

export default React.memo(CutleryOptOut);
